<template>
  <div>
    <intro v-if="display === $Intro" />
    <statements v-if="display === $Statements" />
    <entryAdded v-if="display === $EntryAdded" />
    <noEntriesAdded v-if="display === $NoEntriesAdded" />
    <myWellbeingDiary v-if="display === $MyWellbeingDiary" />
    <statementDetails v-if="display === $StatementDetails" />
    <share v-if="display === $Share" />
    <helpAndSupport v-if="display === $helpAndSupport" />
  </div>
</template>

<script>
import dataStore from "../data/dataStore.js";
import jsonData from "../data/fields.js";
import images from "../../helpers/encodedImages.js";

export default {
  name: "Home",
  data() {
    return {
      idx: 0,
      display: this.$Intro,
      views: [
        this.$Intro,
        this.$Statements,
        this.$EntryAdded,
        this.$NoEntriesAdded,
        this.$MyWellbeingDiary,
        this.$StatementDetails,
        this.$Share,
        this.$helpAndSupport,
      ],
      jsonData: jsonData,
      statementAnswers: {},
      openStatement: {},
      openStatementId: "",
      viewDiary: false,
      accordionActive: true,
      introImg: images.introImg,
      happyImg: images.happy,
      relaxedImg: images.relaxed,
      activeImg: images.active,
      freshAndrestedImg: images.freshAndrested,
      dayOfInterestImg: images.dayOfInterest,
      informationImg: images.information,
      activitiesImg: images.activities,
      communityImg: images.community,
      moreSupportImg: images.moreSupport,
      AlzheimerScotland: images.AlzheimerScotland,
      dhi: images.dhi,
      InverclydeHSCP: images.InverclydeHSCP,
      rds: images.rds,
      agreeIcon: images.agreeIcon,
      mehIcon: images.mehIcon,
      disagreeIcon: images.disagreeIcon
    };
  },
  mounted() {

    // Comment this out locally if needed
    this.getAnswers((items) => {
      this.statementAnswers = items;
      if (Object.keys(this.statementAnswers).length == 0) {
        this.display = this.$Intro;
      } else {
        this.display = this.$Intro;
        this.viewDiary = true;
        this.accordionActive = false;
      }
      this.updateDiary(this.statementAnswers, this.jsonData);
    });
  },
  methods: {
    goTo(v) {
      this.views.forEach((e, i) => {
        if (e == v) {
          this.idx = i;
          this.setDisplay();
        }
      });
    },
    setDisplay() {
      window.scrollTo(0, top);
      this.display = this.views[this.idx];
    },

    ...dataStore,
  },
};
</script>